var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu_footer_block"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('ul',_vm._l((_vm.menu),function(item,j){return _c('li',{key:j},[_c('router-link',{attrs:{"to":{name:item.link}}},[_vm._v(_vm._s(item.title))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }